import { render, staticRenderFns } from "./deliveryMage.vue?vue&type=template&id=1311d372&scoped=true&"
import script from "./deliveryMage.vue?vue&type=script&lang=js&"
export * from "./deliveryMage.vue?vue&type=script&lang=js&"
import style0 from "./deliveryMage.vue?vue&type=style&index=0&id=1311d372&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311d372",
  null
  
)

export default component.exports